<template>
    <v-row class="mx-1 my-2">
        <v-col cols="12">
            <v-row id="div_0">
                <v-col cols="12" md="8" sm="10" class="mx-auto">
                    <p v-if="type == 'Adult'" class="text-center text-h6">
                        {{ 
                            waiver.userId == userStore.id ?
                                    $t("eventWaiver.waiver_template_title_1", language) :    
                                    $t("eventWaiver.waiver_template_title_3", language, {
                                    firstName: waiver.signatoryName, 
                                    lastName: waiver.signatoryLastname
                                })
                        }}<br />
                            {{$t("eventWaiver.waiver_template_title_2",language)}}
                    </p>
                    <p v-else class="text-center text-h6">
                            {{$t("eventWaiver.waiver_template_title_3", language, {
                            firstName: waiver.participantName, 
                            lastName: waiver.participantLastname
                        })}}<br />
                            {{$t("eventWaiver.waiver_template_title_4", language)}}
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="8" sm="10" class="mx-auto">
                    <v-row>
                        <v-col cols="12" class="waiverTitle text-center">
                            <span class="font-weight-bold">{{waiverTitle}}</span>
                        </v-col>
                    </v-row >
                    <v-form ref="formWaiver">
                        <v-card outlined class="pa-4 mt-4">
                            <p>
                                <span class="font-weight-bold">{{$t("eventWaiver.current_ip_address", language)}}:</span> {{currentIp}} {{currentTimeStamp}}<br />
                                <span class="font-weight-bold">{{$t("eventWaiver.document_security_identifier", language)}}:</span> {{documentSecurity}}<br />
                            </p>
                        </v-card>
                        <v-card outlined class="pa-4 mt-4">
                            <p>
                                <span >{{$tc("eventWaiver.eventName", language)}}:</span> <span class="font-weight-bold">{{waiver.eventName}}</span><br />
                                <span >{{$tc("eventWaiver.event_start_date", language)}}:</span> <span class="font-weight-bold">{{waiver.eventStartDate | formatDateForHumans}}</span> <br />
                                <span >{{$tc("eventWaiver.event_end_date", language)}}:</span> <span class="font-weight-bold">{{waiver.eventEndDate | formatDateForHumans}}</span>
                            </p>
                        </v-card>
                        <v-card outlined class="pa-4 mt-4" id="check1" ref="iAgreeContent">
                            <p v-html="waiverText"></p>
                            <v-checkbox
                                ref="iAgree"
                                v-model="iAgree"
                                :label="timeIAgreeLabel"
                                :rules="iAgreeRules"
                                :readonly="waiver.waiverStatus == 'Signed'"
                            ></v-checkbox>
                        </v-card>
                        <v-card v-if="!isLegacySigned" outlined class="pa-4 mt-4" ref="isNegligenceContent">
                            <p>{{ negligenceParagraph }}</p>
                            <v-checkbox
                                ref="isNegligence"
                                v-model="isNegligence"
                                :label="timeIsNegligenceLabel"
                                :rules="isNegligenceRules"
                                :readonly="waiver.waiverStatus == 'Signed'"
                            ></v-checkbox>
                        </v-card>
                        <v-card v-if="type != 'Adult'" outlined class="pa-4 mt-4" id="check2" ref="isCorrectMinorContent">
                            <p class="text-subtitle-1 font-weight-bold">{{$t("eventWaiver.minor_information", language)}}</p>
                            <p class="ml-4">
                                {{$t("common.name", language)}}: <span class="font-weight-bold">{{waiver.participantName}} {{waiver.participantLastname}}</span><br />
                                <template v-if="waiver.participantGender">{{$t("common.gender", language)}}: <span class="font-weight-bold">{{ translateGender(waiver.participantGender) }}</span><br /></template>
                                <template v-if="waiver.participantDateOfBirth">{{$t("common.date_of_birth", language)}}: <span class="font-weight-bold">{{ waiver.participantDateOfBirth | formatDateForHumans(false)}}</span><br /></template>
                                <template v-if="waiver.participantAddress">{{$t("common.address", language)}}: <span class="font-weight-bold">{{ waiver.participantAddress }}</span></template>
                            </p>
                            <v-checkbox
                                ref="isCorrectMinor"
                                v-model="isCorrectMinor"
                                :label="timeIsCorrectMinorLabel"
                                class="ml-4"
                                :rules="isCorrectRules"
                                :readonly="waiver.waiverStatus == 'Signed'"
                            ></v-checkbox>
                        </v-card>
                        <v-card outlined class="pa-4 mt-4 special" id="check2" ref="isCorrectContent"> 
                            <p class="text-subtitle-1 font-weight-bold">{{$t("eventWaiver.your_information",language)}}</p>
                            <p class="ml-4">
                                {{$t("common.name", language)}}: <span class="font-weight-bold">{{waiver.signatoryName}} {{waiver.signatoryLastname}}</span><br />
                                <template v-if="waiver.signatoryDateOfBirth">{{$t("common.date_of_birth", language)}}: <span class="font-weight-bold">{{waiver.signatoryDateOfBirth | formatDateForHumans(false)}}</span><br /></template>
                                <template v-if="waiver.signatoryGender">{{$t("common.gender", language)}}: <span class="font-weight-bold">{{ translateGender(waiver.signatoryGender) }}</span><br /></template>
                                <template v-if="waiver.signatoryEmail">{{$t("common.email", language)}}: <span class="font-weight-bold">{{waiver.signatoryEmail}}</span><br /></template>
                                <template v-if="waiver.signatoryPhone">{{$t("common.phone", language)}}: <span class="font-weight-bold">{{ waiver.signatoryPhone }}</span><br /></template>
                                <template v-if="waiver.signatoryAddress">{{$t("common.address", language)}}: <span class="font-weight-bold">{{ waiver.signatoryAddress }}</span><br /></template>
                            </p>
                             <v-checkbox
                                ref="isCorrect"
                                v-model="isCorrect"
                                :label="timeIsCorrectLabel"
                                class="ml-4"
                                :rules="isCorrectRules"
                                :readonly="waiver.waiverStatus == 'Signed'"
                            ></v-checkbox>
                            <p class="text-subtitle-1 font-weight-bold">{{$t(type === 'Minor' ? "eventWaiver.parent_guardian_signature" : "eventWaiver.participant_signature", language)}}</p>
                            <v-btn :color="buttonColor" class="white--text" @click="openAddSignature">
                                {{$t("eventWaiver.click_to_sign",language)}}
                            </v-btn>
                            <v-card outlined ref="signatureContent" :class="`signatory my-4 ${ hasErrorSignature ? 'errorSignature' : '' }`">
                                <v-card-title class="py-1">{{$t("eventWaiver.signature", language)}}</v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-img :src="signature" height="150"></v-img>
                                    <p v-if="timeSignature">{{timeSignature | formatDateForHumans(false)}}</p>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions><br /></v-card-actions>
                            </v-card>
                            <p v-if="!isLegacySigned" class="font-weight-bold text-center mt-2">
                                {{ waiver && waiver.voluntarilyText ? waiver.voluntarilyText : $t("eventWaiver.voluntarily_text", language) }}
                            </p>
                            <p v-if="hasErrorSignature" class="textErrorSignature text-caption">{{$t("eventWaiver.is_consent_required",language)}}</p>
                        </v-card>
                        <v-card outlined class="pa-4 mt-4 pagebreak" ref="selfieContent" v-if="isPictureRequired">
                            <v-row>
                                <v-col cols="12">
                                    <p class="text-subtitle-1 font-weight-bold text-left">{{$t("eventWaiver.selfie", language)}}</p> 
                                    <p class="text-left">{{ $t('eventWaiver.selfie_description') }}</p>
                                    <div :class="`containImg ${ hasErrorSelfie ? 'errorSelfie' : '' }`">
                                        <img class="imgAvatar" @error="loadPlaceholder" :src="uploadImage_" />
                                        <p v-if="hasErrorSelfie" class="textErrorSelfie text-caption mb-0">{{ $t('eventWaiver.selfie_required') }}</p>
                                    </div>
                                    <div class="d-flex my-1">
                                        <v-btn color="primary" class="white--text btnAvatar" :disabled="disabledOptions" @click="takeSelfie">
                                            {{$t("eventWaiver.take_selfie", language)}}
                                        </v-btn>  
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card v-if="!isLegacySigned" outlined class="pa-4 mt-4" ref="isBoundParticipantContent">
                            <p>{{ boundAgreementParagraph }}</p>
                            <p class="mb-0" style="border-bottom:1px solid #000;padding-bottom:4px;">
                                <span class="font-weight-bold">
                                    {{ type === 'Minor'
                                        ? `${waiver.participantName} ${waiver.participantLastname}`
                                        : `${waiver.signatoryName} ${waiver.signatoryLastname}` }}
                                </span>
                            </p>
                            <p class="text-caption mt-0">{{$t("eventWaiver.name_of_participant", language)}}</p>
                            <v-checkbox
                                ref="isBoundParticipant"
                                v-model="isBoundParticipant"
                                :label="timeIsBoundParticipantLabel"
                                :rules="isBoundParticipantRules"
                                :readonly="waiver.waiverStatus == 'Signed'"
                            ></v-checkbox>
                            <template v-if="type === 'Minor'">
                                <p class="mb-0 mt-4" style="border-bottom:1px solid #000;padding-bottom:4px;">
                                    <span class="font-weight-bold">{{ waiver.signatoryName }} {{ waiver.signatoryLastname }}</span>
                                </p>
                                <p class="text-caption mt-0">{{$t("eventWaiver.name_of_parent", language)}}</p>
                                <v-checkbox
                                    ref="isBoundParent"
                                    v-model="isBoundParent"
                                    :label="timeIsBoundParentLabel"
                                    :rules="isBoundParentRules"
                                    :readonly="waiver.waiverStatus == 'Signed'"
                                ></v-checkbox>
                            </template>
                        </v-card>
                        <v-card outlined class="pa-4 mt-4" id="check3" ref="isConsentContent">
                            <p class="text-subtitle-1 font-weight-bold">{{$t("eventWaiver.electronic_signature_consent",language)}}</p>
                            <p v-html="waiverElectronicConsent" style="margin: 1%;"></p>
                            <v-checkbox
                                ref="isConsent"
                                v-model="isConsent"
                                :label="timeIsConsentLabel"
                                :rules="isConsentRules"
                                :readonly="waiver.waiverStatus == 'Signed'"
                            ></v-checkbox>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-col>
        <v-dialog v-model="dialogSignature" persistent max-width="900px">
            <v-card>
                <v-card-title>{{$t("eventWaiver.signature",language)}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text--primary d-flex" style="min-height: 250px">
                    <DrawSignature
                        v-if="!!waiver" 
                        ref="signature" 
                        @getImage="getImage" 
                        @changeBandSignature="changeBandSignature" 
                        :sizeCanvas="dialogSignature && !!waiver"
                    />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text :color="buttonColor" @click="dialogSignature = false" class="mx-1">
                        {{$t("common.cancel",language)}}
                    </v-btn>
                    <v-btn :color="buttonColor" class="white--text mx-1" @click="clearSignature()" :disabled="disabledSignature">
                        {{$t("common.reset",language)}}
                    </v-btn>
                    <v-btn 
                        :color="buttonColor" 
                        class="white--text mx-1" 
                        @click="saveSignature()"
                        :disabled="disabledSignature"
                    >
                        {{$t("common.acept",language)}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Cropper 
            :ref="`avatarCropperRef`" 
            :buttonColor="buttonColor" 
            type="selfie"
            @uploadCropperImage="uploadCropperImage" 
            style="float: right;" 
        />
    </v-row>
</template>

<script>
import { 
    VRow, VCol, VForm, VCard, VCheckbox, VBtn, VCardTitle, 
    VDivider, VCardText, VImg, VCardActions, VDialog, VSpacer
} from 'vuetify/lib';
import DrawSignature from "@/components/waiver/DrawSignature";
import Cropper from "@/components/images/Cropper.vue"
import { mapState } from "vuex";

const People = Object.freeze({
      firstName: "",
      lastName: "",
      gender: "", 
      birthday: ""
    });

export default {
    components: {
        DrawSignature, Cropper, 
        VRow, VCol, VForm, VCard, VCheckbox, VBtn, VCardTitle, 
        VDivider, VCardText, VImg, VCardActions, VDialog, VSpacer
    },
    props: {
        type: {
            type: String,
            default: 'Adult'
        },
        peopleMinor: Object,
        peopleSignatory: {
            type: Object,
            default: People
        },
        viewBtnNext: {
            type: Boolean,
            default: false
        },
        waiver: {
            type: [Object, Boolean],
            default: false,
            content: {}
        },
        viewBtnBack: {
            type: Boolean,
            default: false
        },
        btnNextBottom: {
            type: String,
            default: "en"
        },
        languageWaiver: {
            type: String,
            default: "en"
        }
    },
    data() {
        return {
            buttonColor: "#000",
            currentIp: "",
            documentSecurity: "",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            iAgree: false,
            electronicConsent:'',
            timeIAgree: "",
            currentTimeStamp: "",
            isCorrect: false,
            timeIsCorrect: "",
            isCorrectMinor: false,
            timeIsCorrectMinor: "",
            signature: null, 
            timeSignature: "",
            hasErrorSignature: false,
            dialogSignature: false,
            disabledSignature: true,
            isConsent: false,
            timeIsConsent: "",
            title:"",
            waiverStatusStatic: ["Signed","Rejected"],
            urlImage: '',
            hasErrorSelfie: false,
            uploadImage_: require("@/assets/images/partPlaceholder.jpg"),
            selfie: null,
            isNegligence: false,       timeIsNegligence: "",
            isBoundParticipant: false, timeIsBoundParticipant: "",
            isBoundParent: false,      timeIsBoundParent: "",
        }
    },
    computed: {
        iAgreeRules() {
            return [
                (val) => val || this.$t("eventWaiver.i_agree_required")
            ]
        },
        isCorrectRules() {
            return [
                (val) => val || this.$t("eventWaiver.is_correct_required")
            ]
        },
        isConsentRules() {
            return [
                (val) => val || this.$t("eventWaiver.is_consent_required")
            ]
        },
        ...mapState({
            userStore: (state) => state.session.user
        }),
        languagePriorityCodes() {
            const current = (this.$i18n?.locale || "en").toString().trim().toLowerCase();
            const configured = Array.isArray(this.$store?.getters?.getLanguages)
                ? this.$store.getters.getLanguages
                    .map((item) => (item?.value || item?.languageCode || "").toString().trim().toLowerCase())
                    .filter((code) => code.length > 0)
                : [];
            const defaults = ["en", "es", "fr"];
            return [...new Set([current, ...configured, ...defaults])];
        },
        contentByCode() {
            return (this.waiver && this.waiver.content && typeof this.waiver.content === "object")
                ? this.waiver.content
                : {};
        },
        language() {
            if (this.waiver && this.waiverStatusStatic.includes(this.waiver.waiverStatus)) {
                if (this.waiver.signedLanguageCode) {
                    return this.waiver.signedLanguageCode.toString().trim().toLowerCase();
                }
                if (this.waiver.waiverText && this.waiver.content) {
                    const signedText = this.waiver.waiverText;
                    for (const code in this.waiver.content) {
                        const item = this.waiver.content[code];
                        if (item && item.waiverText && item.waiverText === signedText) return code.toString().trim().toLowerCase();
                    }
                }
            }
            let language = (this.$i18n?.locale || "en").toString().trim().toLowerCase();
            if (this.waiver && !this.waiverStatusStatic.includes(this.waiver.waiverStatus)) {
                for (const code of this.languagePriorityCodes) {
                    const item = this.contentByCode[code];
                    if (!item) continue;
                    if (Object.prototype.hasOwnProperty.call(item, "available") && item.available === false) continue;
                    const hasText = [
                        item.title,
                        item.waiverText,
                        item.waiverElectronicConsent,
                        item.documentMessage,
                        item.electronicConsent
                    ].some((v) => typeof v === "string" && v.trim().length > 0);
                    if (hasText) {
                        language = code;
                        break;
                    }
                }
            }
            return language;
        },
        firstContent() {
            if (this.waiver && this.waiver.content) {
                for (const code of this.languagePriorityCodes) {
                    const item = this.contentByCode[code];
                    if (!item) continue;
                    if (Object.prototype.hasOwnProperty.call(item, "available") && item.available === false) continue;
                    const hasText = [
                        item.title,
                        item.waiverText,
                        item.waiverElectronicConsent,
                        item.documentMessage,
                        item.electronicConsent
                    ].some((v) => typeof v === "string" && v.trim().length > 0);
                    if (hasText) {
                        return item;
                    }
                }
                for (const property in this.waiver.content) {
                    const item = this.waiver.content[property];
                    if (item && (item.available === undefined || item.available === true)) {
                        return item;
                    }
                }
            }
            return null;
        },
        imageUrl: {
            get() {
                let urlImage = '';

                // Verify waiver and its sub-properties exist before accessing them
                if (this.waiver && this.waiver.content && this.waiver.content[this.language]) {
                    if (!this.waiverStatusStatic.includes(this.waiver.waiverStatus) &&
                        this.waiver.content[this.language].available) {
                    urlImage = this.waiver.content[this.language].headerLogoUrl;
                    return urlImage ? (process.env.VUE_APP_DEV_API_HOST + urlImage) : "";
                    }
                }

                if (this.waiver && this.waiverStatusStatic.includes(this.waiver.waiverStatus)) {
                    urlImage = this.waiver.headerLogoUrl;
                    return urlImage ? (process.env.VUE_APP_DOMAIN + urlImage) : "";
                }

                if (this.firstContent) {
                    urlImage = this.firstContent.headerLogoUrl;
                    return urlImage ? (process.env.VUE_APP_DEV_API_HOST + urlImage) : "";
                }

                return '';  
                },
                set(value) {
                this.urlImage = value;
                }
        },
        hasImage() {
            return this.imageUrl && (this.imageUrl || '').length > 0;
        },
        waiverTitle() {
            if(this.waiver && !this.waiverStatusStatic.includes(this.waiver.waiverStatus) && this.waiver.content) {
                if(this.waiver.content[this.language] && this.waiver.content[this.language].available)
                    return this.waiver.content[this.language].title;
            }
            if(this.waiver && this.waiverStatusStatic.includes(this.waiver.waiverStatus))
            {
                return this.waiver.title;
            }
            if(this.firstContent) {
                return this.firstContent.title;
            }
            return "";
        },
        waiverText() {
            if(this.waiver && !this.waiverStatusStatic.includes(this.waiver.waiverStatus) && this.waiver.content) {
                if(this.waiver.content[this.language] && this.waiver.content[this.language].available)
                    return this.waiver.content[this.language].waiverText;
            }
            if(this.waiver && this.waiverStatusStatic.includes(this.waiver.waiverStatus))
            {
                return this.waiver.waiverText;
            }
            if(this.firstContent) {
                return this.firstContent.waiverText;
            }
            return "";
        },
        waiverElectronicConsent() {
            if(this.waiver && !this.waiverStatusStatic.includes(this.waiver.waiverStatus) && this.waiver.content) {
                if(this.waiver.content[this.language] && this.waiver.content[this.language].available)
                    return this.waiver.content[this.language].waiverElectronicConsent;
            }
            if(this.waiver && this.waiverStatusStatic.includes(this.waiver.waiverStatus))
            {
                return this.waiver.waiverElectronicConsent;
            }
            if(this.firstContent) {
                return this.firstContent.waiverElectronicConsent;
            }
            return "";
        },
        disabledOptions() {
            return this.waiver && this.waiver.waiverStatus == 'Signed';
        },
        isPictureRequired() {
            return this.waiver && this.waiver.isPictureRequired; 
        },
        isNegligenceRules() {
            return [(val) => val || this.$t("eventWaiver.i_agree_negligence_required")];
        },
        isBoundParticipantRules() {
            return [(val) => val || this.$t("eventWaiver.i_agree_bound_participant_required")];
        },
        isBoundParentRules() {
            return [(val) => val || this.$t("eventWaiver.i_agree_bound_parent_required")];
        },
        effectiveIp() {
            return (this.waiver && this.waiverStatusStatic.includes(this.waiver.waiverStatus))
                ? (this.waiver.ipAddress || "")
                : this.currentIp;
        },
        isLegacySigned() {
            // Post-migration rows carry signedLanguageCode (set only by
            // the new snapshot writer). Use it as the explicit schema
            // marker — relying on isBoundParticipantChk would misclassify
            // a new Rejected waiver (the signer rejected before clicking
            // isBoundParticipant) as legacy.
            return !!(this.waiver
                && ["Signed","Rejected"].includes(this.waiver.waiverStatus)
                && !this.waiver.signedLanguageCode);
        },
        negligenceParagraph() {
            return (this.waiver && this.waiver.negligenceText)
                ? this.waiver.negligenceText
                : this.$t("eventWaiver.negligence_text", this.language);
        },
        boundAgreementParagraph() {
            return (this.waiver && this.waiver.boundAgreementText)
                ? this.waiver.boundAgreementText
                : this.$t("eventWaiver.bound_agreement_text", this.language);
        },
        hasFinalSnapshot() {
            return !!(this.waiver && this.waiverStatusStatic.includes(this.waiver.waiverStatus));
        },
        timeIAgreeLabel() {
            if (this.hasFinalSnapshot && this.waiver.isAgreedText) return this.waiver.isAgreedText;
            const t = this.timeIAgree ? this.$options.filters.formatDateForHumans(this.timeIAgree) : "";
            const key = this.type === 'Minor' ? "eventWaiver.i_agree_inherent_risks_minor" : "eventWaiver.i_agree_inherent_risks";
            return this.$t(key, this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsCorrectMinorLabel() {
            if (this.hasFinalSnapshot && this.waiver.isCertifyMinorText) return this.waiver.isCertifyMinorText;
            const t = this.timeIsCorrectMinor ? this.$options.filters.formatDateForHumans(this.timeIsCorrectMinor) : "";
            return this.$t("eventWaiver.is_correct_information", this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsCorrectLabel() {
            if (this.hasFinalSnapshot && this.waiver.isCertifyText) return this.waiver.isCertifyText;
            const t = this.timeIsCorrect ? this.$options.filters.formatDateForHumans(this.timeIsCorrect) : "";
            return this.$t("eventWaiver.is_correct_information", this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsConsentLabel() {
            if (this.hasFinalSnapshot && this.waiver.isConsentText) return this.waiver.isConsentText;
            const t = this.timeIsConsent ? this.$options.filters.formatDateForHumans(this.timeIsConsent) : "";
            return this.$t("eventWaiver.is_consent", this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsNegligenceLabel() {
            if (this.hasFinalSnapshot && this.waiver.isNegligenceText) return this.waiver.isNegligenceText;
            const t = this.timeIsNegligence ? this.$options.filters.formatDateForHumans(this.timeIsNegligence) : "";
            const key = this.type === 'Minor' ? "eventWaiver.i_agree_negligence_minor" : "eventWaiver.i_agree_negligence";
            return this.$t(key, this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsBoundParticipantLabel() {
            if (this.hasFinalSnapshot && this.waiver.isBoundParticipantText) return this.waiver.isBoundParticipantText;
            const t = this.timeIsBoundParticipant ? this.$options.filters.formatDateForHumans(this.timeIsBoundParticipant) : "";
            return this.$t("eventWaiver.i_agree_bound", this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsBoundParentLabel() {
            if (this.hasFinalSnapshot && this.waiver.isBoundParentText) return this.waiver.isBoundParentText;
            const t = this.timeIsBoundParent ? this.$options.filters.formatDateForHumans(this.timeIsBoundParent) : "";
            return this.$t("eventWaiver.i_agree_bound", this.language, { time: t, ip: this.effectiveIp });
        },
    },
    created() {
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {
        this.getIP();
        /*if(this.waiver) {
            this.loadData(this.waiver);
        }*/
    },
    methods: {
        translateGender(gender) {
            const rawValue = (gender || "").toString().trim();
            if (!rawValue) return rawValue;

            const normalized = rawValue.toLowerCase();
            const genderKeyMap = {
                male: "registration.male",
                m: "registration.male",
                masculino: "registration.male",
                hombre: "registration.male",
                homme: "registration.male",
                female: "registration.female",
                f: "registration.female",
                femenino: "registration.female",
                mujer: "registration.female",
                femme: "registration.female",
                other: "common.other",
                o: "common.other",
                otro: "common.other",
                autre: "common.other",
            };

            const key = genderKeyMap[normalized];
            return key ? this.$t(key, this.language) : rawValue;
        },
        getIP() {
            fetch(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/users/current/currentIp`)
            .then(x => x.json())
            .then(({ message }) => {
                this.currentIp = message;
            });
        },
        nextSignItem() {
            this.$emit('nextSignItem');
        },
        backWaiver(){
            this.$emit('backWaiver');
            
        },
        nextSign() {
            if(!this.$refs.formWaiver.validate()) {
                let index = "";
                if(!this.iAgree) index = "iAgree";
                if(this.type == 'Minor') {
                    if(index == "" && !this.isCorrectMinor && this.$refs.isCorrectMinor) index = "isCorrectMinor";
                }
                if(index == "" && !this.isCorrect && this.$refs.isCorrect) index = "isCorrect";
                if(index == "" && !this.signature) index = "signature";
                if(index == "" && this.isPictureRequired && !this.selfie) { 
                    this.hasErrorSelfie = true;
                    index = "selfie";
                }
                if(index == "" && !this.isConsent) index = "isConsent";
                if(!this.isLegacySigned) {
                    if(index == "" && !this.isNegligence) index = "isNegligence";
                    if(index == "" && !this.isBoundParticipant) index = "isBoundParticipant";
                    if(index == "" && this.type === 'Minor' && !this.isBoundParent) index = "isBoundParent";
                }

                if(index != "") {
                    if(index != "signature" && index != "selfie") {
                        const elemCoord = this.$refs[index].$el.getBoundingClientRect();
                        let contElement = document.getElementsByClassName("v-dialog--active");
                        if(contElement.length > 0) {
                            const contCoord = contElement[0].getBoundingClientRect();
                            let newScroll = contElement[0].scrollHeight - contCoord.bottom + elemCoord.top - 70;
                            contElement[0].scrollTo({top: newScroll, behavior: 'smooth'});
                        } else {
                            contElement = document.getElementById("scrolling-techniques-7");
                            const contCoord = contElement.getBoundingClientRect();
                            const breadcrumbHeight = document.getElementById("breadcrumb").clientHeight;
                            let newScroll = 0;
                            if(elemCoord.top < 0) {
                                newScroll = contElement.scrollHeight - contCoord.bottom + elemCoord.top - breadcrumbHeight - 70;
                            } else {
                                newScroll = contElement.scrollTop + elemCoord.top - breadcrumbHeight - 70;
                            }
                            contElement.scrollTo({top: newScroll, behavior: 'smooth'});
                        }
                    } else if(index == "signature") {
                        this.hasErrorSignature =  true;
                        if(this.$refs.signatureContent) this.$refs.signatureContent.$el.scrollIntoView({block: 'center'});
                        if(this.$refs.signature) this.$refs.signature.$el.scrollIntoView({block: 'center'});
                    } else if(this.isPictureRequired && index == "selfie") {
                        this.hasErrorSelfie =  true;
                        if(this.$refs.selfieContent) this.$refs.selfieContent.$el.scrollIntoView({block: 'center'});
                    }
                }
                return false;
            } else if(!this.signature) {
                this.hasErrorSignature =  true;
                if(this.$refs.signatureContent) this.$refs.signatureContent.$el.scrollIntoView({block: 'end'});
                if(this.$refs.signature) this.$refs.signature.$el.focus();
                return false;
            } else if(this.isPictureRequired && !this.selfie) {
                this.hasErrorSelfie =  true;
                if(this.$refs.selfieContent) this.$refs.selfieContent.$el.scrollIntoView({block: 'center'});
                return false;
            }
            return true;
        },
        openAddSignature() {
            this.dialogSignature = true;
            if(this.$refs.signature)
                this.$refs.signature.cleanCanvas();
        },
        getTimeStamp() {
            const now = new Date();
            let month = now.getMonth() + 1;
            month = month < 10 ? `0${month}` : month;
            let day = now.getDate() < 10 ? `0${now.getDate()}` : now.getDate();
            return `${now.getFullYear()}-${month}-${day} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        },
        changeBandSignature({ value }) {
            this.disabledSignature = value;
        },
        getImage(image) {
            this.signature = image;
        },
        clearSignature() {
            if(this.$refs.signature)
                this.$refs.signature.cleanCanvas();
        },
        saveSignature() {
            this.$refs.signature.getImage();
            this.timeSignature = this.getTimeStamp();
            this.dialogSignature = false;
        },
        loadData(waiver) {
            this.documentSecurity = waiver.documentUUID;
            this.electronicConsent = waiver.waiverElectronicConsent;
            // Only honour persisted checkbox + signature timestamps when
            // the row is actually Signed. NotSigned / Rejected rows can
            // carry stale chk fields from aborted attempts; rendering
            // those would re-tick the boxes "by a ghost" and block the
            // signer from clearing them (issue #113 follow-up).
            const isFinalSigned = waiver && waiver.waiverStatus === 'Signed';
            const agreedChk = isFinalSigned ? waiver.isAgreedChk : null;
            const consentChk = isFinalSigned ? waiver.isElectronicConsentChk : null;
            const certifyChk = isFinalSigned ? waiver.isCertifyChk : null;
            const negligenceChk = isFinalSigned ? waiver.isNegligenceChk : null;
            const boundParticipantChk = isFinalSigned ? waiver.isBoundParticipantChk : null;
            const boundParentChk = isFinalSigned ? waiver.isBoundParentChk : null;
            const signatureImage = isFinalSigned ? waiver.signatureImage : null;

            this.iAgree = !!agreedChk;
            this.timeIAgree = agreedChk ? agreedChk : "";
            this.signature = signatureImage;
            this.timeSignature = signatureImage ? this.getTimeStamp() : "";
            this.isConsent = !!consentChk;
            this.timeIsConsent = consentChk ? consentChk : "";
            if(this.type == 'Minor') {
                this.isCorrect = !!certifyChk;
                this.isCorrectMinor = !!certifyChk;
                this.timeIsCorrectMinor = certifyChk ? certifyChk : "";
                this.timeIsCorrect = "";
            } else {
                this.isCorrect = !!certifyChk;
                this.timeIsCorrect = certifyChk ? certifyChk : "";
                this.isCorrectMinor = false;
                this.timeIsCorrectMinor = "";
            }
            this.isNegligence = !!negligenceChk;
            this.timeIsNegligence = negligenceChk ? negligenceChk : "";
            this.isBoundParticipant = !!boundParticipantChk;
            this.timeIsBoundParticipant = boundParticipantChk ? boundParticipantChk : "";
            this.isBoundParent = !!boundParentChk;
            this.timeIsBoundParent = boundParentChk ? boundParentChk : "";
            this.selfie = isFinalSigned ? waiver.signatoryPicture : null;
            this.hasErrorSignature = false;
            this.hasErrorSelfie = false;
        },
        processErrorImg() {
            this.urlImage = "error";
        },
        loadPlaceholder(e) {
            e.target.src = this.errorImage;
        },
        takeSelfie() {
            let selfieComponent = this.$refs.avatarCropperRef;
            if(selfieComponent) {
                selfieComponent.openSelfie();
            }
        },
        uploadCropperImage(data) {
            const { base64Image, fileName } = data;      
            const base64Data = base64Image.replace(/^data:image\/\w+;base64,/, "");
            var byteCharacters = atob(base64Data);

            var byteArray = new Uint8Array(byteCharacters.length);

            for (var i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
            }

            var blob = new Blob([byteArray], { type: 'image/png' });

            // Create a File object from the Blob
            var file = new File([blob], 'filename.png', { type: 'image/png' });

            this.uploadImage_ = base64Image;
            this.selfie = base64Image;
            this.fileImage = file;
            this.fileName = fileName;
        }
    },
    watch: {
        iAgree(val) {
            if(val && this.waiver && this.waiver.isAgreedChk) return;
            if(val) {
                this.timeIAgree = this.getTimeStamp();
            } else {
                this.timeIAgree = "";
            }
        },
        isCorrectMinor(val) {
            if(val && this.waiver && this.waiver.isCertifyChk) return;
            if(val) {
                this.timeIsCorrectMinor = this.getTimeStamp();
            } else {
                this.timeIsCorrectMinor = "";
            }
        },
        isCorrect(val) {
            if(val && this.waiver && this.waiver.isCertifyChk) return;
            if(val) {
                this.timeIsCorrect = this.getTimeStamp();
            } else {
                this.timeIsCorrect = "";
            }
        },
        signature(val) {
            if(val) {
                this.timeSignature = this.getTimeStamp();
                this.hasErrorSignature = false;
            } else {
                this.timeSignature = "";
            }
        },
        isConsent(val) {
            if(val && this.waiver && this.waiver.isElectronicConsentChk) return;
            if(val) {
                this.timeIsConsent = this.getTimeStamp();
            } else {
                this.timeIsConsent = "";
            }
        },
        dialogSignature() {
            // if(!val && !this.signature) {
            //     this.hasErrorSignature = true;
            // }
        },
        waiver(val) {
            this.loadData(val);
        },
        selfie(val) {
            if(val) {
                this.hasErrorSelfie = false;
            }
        },
        isNegligence(val) {
            if(val && this.waiver && this.waiver.isNegligenceChk) return;
            this.timeIsNegligence = val ? this.getTimeStamp() : "";
        },
        isBoundParticipant(val) {
            if(val && this.waiver && this.waiver.isBoundParticipantChk) return;
            this.timeIsBoundParticipant = val ? this.getTimeStamp() : "";
        },
        isBoundParent(val) {
            if(val && this.waiver && this.waiver.isBoundParentChk) return;
            this.timeIsBoundParent = val ? this.getTimeStamp() : "";
        },
    }
}
</script>

<style>
.signatory .v-card__title {
  background: none !important;
}
.signatory .v-image {
    max-height: 130px;
}
.signatory .v-image .v-image__image {
    background-size: contain;
}
.signatory.errorSignature, .signatory.errorSignature .v-divider, .errorSelfie {
    border-color: #ff5252 !important;
}
.textErrorSignature, .textErrorSelfie {
    color: #ff5252 !important;
}
.waiverTitle{
    text-align: left;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: 2em;
    text-transform: uppercase;
    line-height: 1.2;
}
@media (min-width: 1024px) and (max-width: 1263px) {
    .waiverTitle{
        font-size: 1.8em;
    }
}
@media (min-width: 700px) and (max-width: 1023px) {
    .waiverTitle{
        font-size: 1.5em;
    }
}
@media (max-width: 699px) {
    .waiverTitle{
        font-size: 1.3em;
    }
}
.containImg {
    padding: 4px;
    border-radius: 4px 4px 0 0;
    border: 1px solid #ddd;
    background-color: white;
    padding-bottom: 20px;
    max-width: 250px;
}
.imgAvatar { max-width: 100%; object-fit: contain; }
.btnAvatar { max-width: 250px; width: 100%; }
</style>